import LoyaltyTierIcon from 'LuxKit/Icons/loyalty/LoyaltyTierIcon'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-shrink: 0;
`

const IconWrapper = styled.div<{ $zIndex: number; $offset?: boolean }>`
  z-index: ${props => props.$zIndex};
  margin-left: ${props => props.$offset ? rem(-6) : 0};
`

interface Props {
  size?: number
}

function StackedLoyaltyTierIcon({ size = 16 }: Props) {
  return (
    <Container>
      <IconWrapper $zIndex={1}>
        <LoyaltyTierIcon tier="bronze" size={size} />
      </IconWrapper>
      <IconWrapper $zIndex={3} $offset>
        <LoyaltyTierIcon tier="gold" size={size} />
      </IconWrapper>
      <IconWrapper $zIndex={2} $offset>
        <LoyaltyTierIcon tier="silver" size={size} />
      </IconWrapper>
    </Container>
  )
}

export default StackedLoyaltyTierIcon
